// extracted by mini-css-extract-plugin
module.exports = {"container":"_32LN3","empty":"oadGu","highQualityFrame":"_2bUJT","lowQualityFrame":"_3bKMM","thumbText":"_1JzaC"};